// This initial state will be used in the student section's Redux store.
const state = {
  students: {
    studentUserLoading: true,
    studentUserError: "",
    studentUserInfo: [],
    advancedSearch: {},
    total: 0,
    page: 0,
    limit: 25,
    isLoading: false,
  },
};

export default state;
